export const DEBOUNCE_SEARCH_TIMEOUT = 500;
export const DEBOUNCE_GET_AS_LOADING = 100;
